module.exports = __webpack_public_path__ + "static/media/penny-arcade.8d7f2162.svg";